import React from 'react';

import { Tooltip } from '@buildoutinc/blueprint-react/ui/Tooltip';

interface Props {
  channels?: string[];
}

export default function SyndicationDisconnectMessage({ channels }: Props) {
  if (!channels || channels.length === 0) return null;

  const label = channels.length === 1 ? '1 channel' : `${channels.length} channels`;

  return (
    <p className="form-text strong">
      Note: Disconnecting syndication from this listing will remove your listing from{' '}
      <Tooltip.Provider>
        <Tooltip>
          <Tooltip.Trigger render={<span className="text-decoration-underline" />}>
            {label}
          </Tooltip.Trigger>
          <Tooltip.Content side="bottom">
            {channels.join(' | ')}
          </Tooltip.Content>
        </Tooltip>
      </Tooltip.Provider>
      .
    </p>
  );
}
